module.exports = __webpack_public_path__ + "static/media/flag.ffd4c5a7.svg";